module.exports = __webpack_public_path__ + "img/workflow.59941a88.svg";